import type { CampaignQueryVariables } from '../types';

const campaigns = () => [{ entity: 'campaigns' }] as const;

const campaignList = (variables: CampaignQueryVariables) =>
  [{ ...campaigns()[0], scope: 'list', variables }] as const;

const advertisers = () => [{ entity: 'advertisers' }] as const;

export const campaignQueryKeys = {
  all: campaigns,
  list: campaignList,
  advertisers,
};
